const getBackendUrl = () => {
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL.replace(/\/$/, '');
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return 'http://localhost:3060';
};

const config = {
  backendUrl: getBackendUrl(),
};

export function getImageUrl(imagePath) {
  if (!imagePath) return null;
  if (imagePath.startsWith('/images/')) {
    return imagePath;
  }
  return `${config.backendUrl}${imagePath}`;
}

export { config as urlConfig };
